<template>
  <div>
    <!-- if logged in -->
    <div v-if="stored_login">
      <v-menu offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            text
            small
            v-bind="attrs"
            v-on="on"
            color="primary"
            @click="doSubscriptionCheck()"
          >
            <span v-if="!$vuetify.breakpoint.mobile || menuItem">
              <!-- {{ attrs["aria-expanded"] }} -->
              {{ stored_login }}
              <v-icon class="ml-3" v-if="menuItem"
                >mdi-chevron-{{
                  attrs["aria-expanded"] == "true" ? "up" : "down"
                }}</v-icon
              >
            </span>
            <span v-else>
              <v-icon small>mdi-account</v-icon>
            </span>
            <v-icon
              v-if="!activeSubscription || yearlyExpiresSoon"
              :color="!activeSubscription ? 'red' : 'orange'"
              class="ml-1"
              small
              >mdi-alert</v-icon
            >
            <v-icon v-else class="ml-1 d-none d-sm-flex">mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list nav dense class="overflow-y-auto scrollHeight">
          <v-list-item
            v-if="!activeSubscription || yearlyExpiresSoon"
            :href="AMEMBER_SIGNUP"
            two-line
          >
            <v-list-item-icon
              ><v-icon class="mr-1">mdi-autorenew</v-icon></v-list-item-icon
            >
            <v-list-item-content>
              <v-list-item-title v-if="!activeSubscription"
                ><v-icon color="red" class="mr-1" small>mdi-alert</v-icon
                >Subscription expired
              </v-list-item-title>
              <v-list-item-title v-else
                ><v-icon color="orange" class="mr-1" small>mdi-alert</v-icon
                >Subscription expires in
                {{ Math.ceil(Math.abs(activeSubscription)) }} days
              </v-list-item-title>
              <v-list-item-subtitle> Renew Subscription</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="activeSubscription" :href="AMEMBER_MEMBER">
            <v-list-item-icon><v-icon>mdi-account</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Subscription through {{ latestExpiration }}
                <span v-if="renewingSubscription">(automatically renews)</span>
              </v-list-item-title>
              <v-list-item-subtitle
                >Manage User &amp; subscription</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="
              logoutUser();
              $emit('loggedOut');
            "
          >
            <v-list-item-icon>
              <v-icon>mdi-account-off</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Log Out </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <!-- /if logged in -->
    <!-- if not logged in -->
    <div v-else>
      <v-dialog v-model="dialog" width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            x-small
            :text="textButton"
            color="primary"
            depressed
          >
            <span v-if="!$vuetify.breakpoint.mobile || menuItem">{{
              buttonLabel
            }}</span>

            <v-icon v-else>mdi-account-alert-outline</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Login
            <v-spacer></v-spacer>
            <v-btn color="primary" icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-4">
            <v-text-field
              v-model="username_txt"
              placeholder="Username Or Email"
              @keypress="error = null"
            ></v-text-field>
            <v-text-field
              v-model="password_txt"
              placeholder="Password"
              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPass ? 'text' : 'password'"
              @click:append="showPass = !showPass"
              @keypress="error = null"
              @keypress.enter="userLogin()"
            ></v-text-field>
            <v-alert
              text
              type="error"
              v-if="error"
              class="my-2"
              transition="scale-transition"
              >{{ error }}</v-alert
            >
            <div class="d-flex flex-row">
              <div>
                <v-btn
                  x-small
                  text
                  color="primary"
                  @click="showPasswordDialog()"
                  ><v-icon small class="mr-1">mdi-lock-question</v-icon>Forgot
                  password</v-btn
                >
                <br />
                <v-btn x-small text color="primary" :href="AMEMBER_SIGNUP">
                  <v-icon small class="mr-1">mdi-account-plus</v-icon>
                  Register</v-btn
                >

                <br />

                <v-btn
                  x-small
                  text
                  color="green"
                  href="/documentation/about-eyedock-pro"
                  ><v-icon small class="mr-1">mdi-information-outline</v-icon
                  >About EyeDock Pro</v-btn
                >
              </div>
              <v-spacer></v-spacer>
              <v-btn
                @click="userLogin()"
                depressed
                color="primary"
                :disabled="!canSubmit"
                :loading="loading"
                >Log in</v-btn
              >
            </div>

            <!-- {{ apiResponse }} -->
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <!-- /if not logged in -->

    <password-reset-dialog
      :openDialog="passwordDialog"
      :externalUsername="username_txt"
      @closePasswordDialog="passwordDialog = false"
    ></password-reset-dialog>

    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      color="success"
      v-if="apiResponse"
    >
      Welcome {{ apiResponse.login }}
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbar = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import UserMixin from "@/assets/js/UserMixin";
import ApiServices from "@/services/ApiServices";
import HardLinksMixin from "@/assets/js/HardLinksMixin.js";

export default {
  name: "UserLogin",
  mixins: [UserMixin, HardLinksMixin],
  components: {
    PasswordResetDialog: () =>
      import("@/components/universalStuff/PasswordResetDialog.vue"),
  },
  props: {
    textButton: {
      type: Boolean,
      default: true,
    },
    buttonLabel: { type: String, default: "Login/Subscribe" },
    menuItem: { type: Boolean, default: false },
    redirect: null,
  },
  data: function () {
    return {
      dialog: false,
      passwordDialog: false,
      username_txt: null,
      password_txt: null,
      failure: false,
      // subscribed: false,
      // isLoggedIn: false,
      showPass: false,
      apiResponse: null,
      error: null,
      loading: false,
      snackbar: false,
      snackbarTimeout: 3000,
    };
  },
  methods: {
    showPasswordDialog() {
      this.dialog = false;
      this.passwordDialog = true;
    },
    gotoSignup() {
      this.resetLastAuthenticated();
      window.location.href = this.AMEMBER_SIGNUP;
    },

    // userLogout() {
    //   this.setUserData(null); // from userMixin
    // },
    userLogin() {
      this.loading = true;
      let u = encodeURIComponent(this.username_txt.trim());
      let p = encodeURIComponent(this.password_txt.trim());
      ApiServices.loginWithUserAndPass(u, p)
        .then((response) => {
          let result = response.data;
          // console.log(result);
          this.loading = false;
          let ok = result.ok;
          this.error = !ok ? result.msg : null;
          if (ok && result.login) {
            this.snackbar = true;
            this.apiResponse = result;
            this.dialog = false;
            result.lastAuthenticated = this.formatDate();
            this.setUserData(result);
            if (this.redirect) this.doRedirect();
            if (this.isSubscribed) this.$emit("loggedIn");
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          console.log(error);
          this.error = "An API error occurred";
          this.loading = false;
        });
    },
    doRedirect() {
      if (this.isSubscribed) this.$router.push({ path: this.redirect });
    },
    doSubscriptionCheck() {
      console.log("subscriptionCheck");
      if (!this.isSubscribed && this.isLoggedIn) this.periodicLoginCheck();
    },
  },
  computed: {
    canSubmit: function () {
      return (
        this.username_txt &&
        this.username_txt != "" &&
        this.password_txt &&
        this.password_txt != ""
      );
    },
    buttonClass: function () {
      let aClass = "";
      // if (this.$vuetify.breakpoint.smAndUp){

      // }
      return aClass;
    },
  },
  mounted: function () {
    // console.log(this.latestExpiration);
  },
};
</script>

<style scoped></style>
